const SQL_SERVER_ROW_VERSION_LENGTH = 8;
const INVALID_ETAG_MESSAGE = 'نسخه اطلاعات معتبر نیست؛ صفحه را تازه‌سازی کنید و دوباره تلاش کنید.';

const unwrapEtag = (value: string): string => {
  let token = value.trim();

  for (let attempt = 0; attempt < 4; attempt += 1) {
    if (token.toLowerCase().startsWith('w/')) token = token.slice(2).trim();

    if (token.startsWith('\\"') && token.endsWith('\\"') && token.length >= 4) {
      token = token.slice(2, -2).trim();
      continue;
    }

    if (token.startsWith('"') && token.endsWith('"') && token.length >= 2) {
      token = token.slice(1, -1).trim();
      continue;
    }

    break;
  }

  return token;
};

const canonicalRowVersion = (value: string): string => {
  const token = unwrapEtag(value);
  const base64 = token.replace(/-/g, '+').replace(/_/g, '/');
  const remainder = base64.length % 4;
  const padded = remainder === 0 ? base64 : remainder === 2 ? `${base64}==` : remainder === 3 ? `${base64}=` : '';

  if (!padded || !/^[A-Za-z0-9+/]+={0,2}$/.test(padded)) throw new Error(INVALID_ETAG_MESSAGE);

  try {
    const decoded = atob(padded);
    if (decoded.length !== SQL_SERVER_ROW_VERSION_LENGTH) throw new Error(INVALID_ETAG_MESSAGE);
    return btoa(decoded);
  } catch {
    throw new Error(INVALID_ETAG_MESSAGE);
  }
};

export const toIfMatchHeader = (value: string): string => `"${canonicalRowVersion(value)}"`;

export const resolveResponseEtag = (headers: Headers, rowVersion: string): string => {
  const headerValue = headers.get('ETag');
  if (headerValue) {
    try {
      return toIfMatchHeader(headerValue);
    } catch {
      // Fall back to the response body for servers/proxies that alter ETag headers.
    }
  }

  return toIfMatchHeader(rowVersion);
};
